/**
 * @generated SignedSource<<151b6ff9d28df7a94eb8f1723bc0a9c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type hierarchyToggle_issueNavigator_HierarchyToggleItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HierarchyToggle">;
  readonly " $fragmentType": "hierarchyToggle_issueNavigator_HierarchyToggleItem";
};
export type hierarchyToggle_issueNavigator_HierarchyToggleItem$key = {
  readonly " $data"?: hierarchyToggle_issueNavigator_HierarchyToggleItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"hierarchyToggle_issueNavigator_HierarchyToggleItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HierarchyToggle"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "c2d6e38da80c7d1e0b4bbac437a0faf0";

export default node;
